/**
 * Carries the AppSite/AppView that an IAppSite handler resolves a request to.
 *
 * Responsibilities:
 * - Hold the resolved AppSite/AppView to render (unchanged when no redefinition applies)
 * - Provide a named, extensible return shape (preferred over a tuple for cross-language portability)
 */
export class AppSiteResult {
    /**
     * The AppSite to render.
     */
    appSite: string;

    /**
     * The AppView to render (may be empty).
     */
    appView: string;

    /**
     * Stable token describing WHY this handler resolved as it did (e.g. "forward-bootstrap",
     * "reverse-bootstrap", "auth-gate"). Empty for a no-op (no redefinition). Part of the cross-lang
     * navigation contract — captured into the NavigationTrace and assertable in stateValidations.
     */
    reason: string;

    /**
     * Creates a resolution result for the supplied AppSite/AppView (with an optional reason token).
     */
    constructor(appSite: string, appView: string, reason: string = '') {
        this.appSite = appSite;
        this.appView = appView;
        this.reason = reason || '';
    }
}
